import { Component, ReactNode } from 'react'

import Modal from '../../libs/ui/modal/Modal'
import ModalWaith from "../../libs/ui/modal/ModalWaith"
import Input from '../../libs/ui/inputs/Input'

import { authFetch } from '../../libs/cookie/Cookie'
import User from '../../libs/user/User'
import { EMAIL_PATTERN } from '../../libs/validation/stringRegex'

import { USER_LOGIN_URL } from '../../costants'

interface LogingProps {
    isOpen: boolean,
    callBackToggle: Function
    callBackGoToSigIn?: Function
}

interface LogInState {
    userName: string | undefined
    pass: string | undefined
    result: any
    error: string | undefined
    waith: boolean
}

class ModalLogIn extends Component<LogingProps, LogInState> {

    constructor (props: any) {
        super(props)

        this.state = {
            userName: undefined,
            pass: undefined,
            result: undefined,
            error: undefined,
            waith: false
        }

        this.setUserName = this.setUserName.bind(this)
        this.setPass = this.setPass.bind(this)
        this.logInUser = this.logInUser.bind(this)
        this.printError = this.printError.bind(this)
    }

    render(): ReactNode {
        return (
            <>
                <Modal
                    title='Che bello rivederti!'
                    buttonText='Accedi'
                    isOpen={this.props.isOpen && !this.state.waith}
                    isLogIn={true}
                    callBackGoToSigIn={this.props.callBackGoToSigIn}
                    callBackSendData={this.logInUser}
                    callBackToggle={this.props.callBackToggle}
                    error={this.state.error}
                >
                    <p>Effettua il login per accedere a tutti i vantaggi della tua area personale.</p>

                    <Input 
                        id='logIn-user'
                        label='E-mail' 
                        name='user' 
                        value={this.state.userName}
                        type='email'
                        callback={this.setUserName}
                        regexp={EMAIL_PATTERN}
                        errorDisplayMsg='Email non valida'
                        error={this.state.error}
                        autoComplete='off'
                    />

                    <Input 
                        id='logIn-pass'
                        label='Password'
                        name='password'
                        value={this.state.pass}
                        type='password'
                        callback={this.setPass}
                        error={this.state.error}
                        autoComplete='off'
                    />

                    <br/>
                    <a 
                        href='http://www.6sicuro.it/preventivi/area-personale/password-dimenticata' 
                        className='colorSecondaryGreen' 
                        target='_blank' rel='noopener noreferrer'
                    >
                        Hai dimenticato la password?
                    </a>
                </Modal>

                <ModalWaith isOpen={this.state.waith} isLoginForm={true} />
            </>
        )
    }

    private logInUser () {

        this.setState({
            waith: true
        },
        () => {
            authFetch (
                USER_LOGIN_URL, 
                {
                    method: "post",
                    body: JSON.stringify({
                        email: this.state.userName,
                        password: this.state.pass
                    })
                },
                () => {}
            )
            .then ( jsonObj => {

                if (jsonObj?.success === false) {
                    this.printError ( jsonObj.error_code )
                } 
                else {
                    this.setState({
                        error: undefined,
                        waith: false
                    }, () => {
                        if (this.props.callBackToggle) {
                            this.props.callBackToggle (
                                new User (jsonObj)
                            )
                        }
                    })
                }

            }).catch( (error) => {
                this.printError ( 'Inpossibile contattare il server, riprova più tardi' )
            })
        })

    }

    private printError (errorString: string) {
        let recivedError: string | undefined = 'Errore generico'

        if (errorString === "LOGIN_FAILED" || errorString === "VALIDATION_ERROR") {
            recivedError = 'Password o email errata'
        } 
        else if (errorString === "USER_NOT_ACTIVATED") {
            recivedError = 'Prima di procedere controlla la tua email e attiva il tuo account'
        }
        else if (errorString === "MISSING_TOKEN") {
            // voglio semplicemente che risulti non loggato.. non dovrebbe mai succedere
            recivedError = undefined
        }

        this.setState({
            error: recivedError,
            waith: false
        })
    }

    private setUserName (val: string | undefined) {
        this.setState({
            userName: val,
            error: undefined
        })
    }

    private setPass (val: string | undefined) {
        this.setState({
            pass: val,
            error: undefined
        })
    }
}

export default ModalLogIn